const data = [
  {
    id: 1,
    name: "Ayşe yılmaz",
    job: "Developer",
    comment: "Uygulamayı çok beğendim...",
    img:"https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883334/person-1_rfzshl.jpg",
  },
  {
    id: 2,
    name: "İsmail Can",
    job: "Tester",
    comment: "Uygulama çok zor...",
    img: "https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883417/person-3_ipa0mj.jpg",
  },
  {
    id: 3,
    name: "Canan Can",
    job: "Grafiker",
    comment: "Tebrikler çok başarılı...",
    img: "https://images.unsplash.com/photo-1610564558732-a36a4e28151c?ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8cG9ydGFpdHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 4,
    name: "Tayyar Baki",
    job: "Stajer",
    comment: "Geliştirilmesi gerekiyor...",
    img: "https://images.unsplash.com/photo-1552058544-f2b08422138a?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8cGVyc29ufGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
  },
];

export default data;
